export const TYPELAYER = 'TYPELAYER'